import { React } from "react";
import { Button, Form, Input } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm, RightDrawerContainer } from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DisabledStyles } from "../../pageStyled";

const { TextArea } = Input;

const HoldApprovalOrdersData = (props) => {
  return (
    <RightDrawerSidebar
      title="Hold Order"
      subtitle=""
      visible={props.visible}
      onClose={props.onCloseGrade}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <HaberForm>
            <Form
              name="basic"
              autoComplete="off"
              className="haberLogin haberSignup"
              style={{ marginTop: "0" }}
            >
              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Order Code</h5>
                  <p>A unique auto-generated code to identify order</p>
                </div>
                <Form.Item name="ordercode" rules={[{ required: true }]}>
                  <DisabledStyles>
                    <Input
                      defaultValue="ITC21082021"
                      disabled
                      className="requestChangeValue"
                    />
                  </DisabledStyles>
                </Form.Item>
              </div>

              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Reason for holding the order</h5>
                  <p>Please specify the reason</p>
                </div>
                <Form.Item
                  name="Reason for holding"
                  rules={[{ required: true }]}
                  className=""
                >
                  <TextArea
                    maxLength={100}
                    style={{ height: 90 }}
                    placeholder="Mention the Reason here"
                  />
                </Form.Item>
              </div>
              <div className="buttonFlex fixedBtm">
                <Form.Item>
                  <Button htmlType="submit" className="themeBtn">
                    <Iconmoon icon="wrong" size={16} color="#ffffff" /> Hold
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </HaberForm>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
};

export default HoldApprovalOrdersData;
